/**
 * OVERRIDE PersonalTools.jsx
 * REASON: Remove menu for profil and settings from personaltools since in DLR they do not use them
 * FILE: https://github.com/plone/volto/tree/af81631b8ea4d6e5e3d5008d8f291ab4c2784a7a
 * FILE VERSION: Volto 16.0.0-alpha.42
 * DATE: 2022-08-31, 2022-10-07
 * DEVELOPER: @sneridagh
 * CHANGELOG:
 *  - Remove menu for profil and settings from personaltools (#608) @sneridagh
 *
 * Every change is marked with a JSX comment at the beginning and end of the change:
 *
 *   START CUSTOMIZATION
 *   <CUSTOMIZATION>
 *   END CUSTOMIZATION
 */
/**
 * PersonalTools container.
 * @module components/manage/Toolbar/PersonalTools
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import jwtDecode from 'jwt-decode';
import cx from 'classnames';
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl';
import { Icon } from '@plone/volto/components';
import { getUser } from '@plone/volto/actions';
import { Pluggable } from '@plone/volto/components/manage/Pluggable';
import {
  expandToBackendURL,
  getBaseUrl,
  userHasRoles,
} from '@plone/volto/helpers';
import { isLiveSite } from 'volto-dlr/helpers/context';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import logoutSVG from '@plone/volto/icons/log-out.svg';
import rightArrowSVG from '@plone/volto/icons/right-key.svg';

import backSVG from '@plone/volto/icons/back.svg';
import cameraSVG from '@plone/volto/icons/camera.svg';

const messages = defineMessages({
  back: {
    id: 'Back',
    defaultMessage: 'Back',
  },
  logout: {
    id: 'Logout',
    defaultMessage: 'Logout',
  },
  preferences: {
    id: 'Preferences',
    defaultMessage: 'Preferences',
  },
  profile: {
    id: 'Profile',
    defaultMessage: 'Profile',
  },
  userAvatar: {
    id: 'user avatar',
    defaultMessage: 'user avatar',
  },
  impersonate: {
    id: 'impersonate',
    defaultMessage: 'Impersonate user',
  },
});

/**
 * Toolbar container class.
 * @class PersonalTools
 * @extends Component
 */
class PersonalTools extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    user: PropTypes.shape({
      fullname: PropTypes.string,
      email: PropTypes.string,
      home_page: PropTypes.string,
      location: PropTypes.string,
    }).isRequired,
    userId: PropTypes.string.isRequired,
    getUser: PropTypes.func.isRequired,
    loadComponent: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this.props.getUser(this.props.userId);
  }

  push = (selector) => {
    this.setState(() => ({
      pushed: true,
    }));
    this.props.loadComponent(selector);
  };

  pull = () => {
    this.props.unloadComponent();
  };

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    return (
      <div
        className={cx('personal-tools pastanaga-menu', {
          'has-inner-actions': this.props.hasActions,
        })}
        style={{
          flex: this.props.theToolbar.current
            ? `0 0 ${
                this.props.theToolbar.current.getBoundingClientRect().width
              }px`
            : null,
        }}
      >
        <header className="header">
          <button className="back" onClick={this.pull}>
            <Icon
              name={backSVG}
              size="30px"
              title={this.props.intl.formatMessage(messages.back)}
            />
          </button>
          <div className="vertical divider" />
          <h2>
            {this.props.user.fullname
              ? this.props.user.fullname
              : this.props.user.username}
          </h2>
          <Link
            id="toolbar-logout"
            to={`${getBaseUrl(this.props.pathname)}/logout`}
          >
            <Icon
              className="logout"
              name={logoutSVG}
              size="30px"
              title={this.props.intl.formatMessage(messages.logout)}
            />
          </Link>
        </header>
        <div className={cx('avatar', { default: !this.props.user.portrait })}>
          {this.props.user.portrait ? (
            <img
              src={expandToBackendURL(this.props.user.portrait)}
              alt={this.props.intl.formatMessage(messages.userAvatar)}
            />
          ) : (
            <Icon name={cameraSVG} size="96px" />
          )}
        </div>
        {/* <Stats /> Maybe we can find a good fit in the future for this visual element */}
        <div className="pastanaga-menu-list">
          {/* This (probably also) should be a Component by itself*/}
          <ul>
            {/* START CUSTOMIZATION */}
            {/* <li>
              <button
                aria-label={this.props.intl.formatMessage(messages.profile)}
                onClick={() => this.push('profile')}
              >
                <FormattedMessage id="Profile" defaultMessage="Profile" />
                <Icon name={rightArrowSVG} size="24px" />
              </button>
            </li> */}
            {/* <li>
              <button
                aria-label={this.props.intl.formatMessage(messages.preferences)}
                onClick={() => this.push('preferences')}
              >
                <FormattedMessage
                  id="Preferences"
                  defaultMessage="Preferences"
                />
                <Icon name={rightArrowSVG} size="24px" />
              </button>
            </li> */}
            {/* END CUSTOMIZATION */}

            {userHasRoles(this.props.user, [
              'Site Administrator',
              'Manager',
            ]) && (
              <>
                {!isLiveSite() ? (
                  <li>
                    <button
                      aria-label={this.props.intl.formatMessage(
                        messages.impersonate,
                      )}
                      onClick={() => this.push('impersonate')}
                    >
                      {this.props.intl.formatMessage(messages.impersonate)}
                    </button>
                  </li>
                ) : null}
                <li>
                  <Link to="/controlpanel">
                    <FormattedMessage
                      id="Site Setup"
                      defaultMessage="Site Setup"
                    />
                    <Icon name={rightArrowSVG} size="24px" />
                  </Link>
                </li>
              </>
            )}
            <Pluggable name="toolbar-user-menu" />
          </ul>
        </div>
      </div>
    );
  }
}

export default compose(
  injectIntl,
  withRouter,
  connect(
    (state, props) => ({
      pathname: props.location.pathname,
      user: state.users.user,
      userId: state.userSession.token
        ? jwtDecode(state.userSession.token).sub
        : '',
    }),
    { getUser },
  ),
)(PersonalTools);
